import {
  base64StringJsonFormat,
  booleanJsonFormat,
  objectJsonFormat,
  stringJsonFormat,
  typedStringJsonFormat,
} from "@redotech/json/format";

export enum CallFlow {
  CUSTOMER_CALLING_SUPPORT_AGENT = "customer-calling-support-agent",
  SUPPORT_AGENT_CALLING_CUSTOMER = "support-agent-calling-customer",
}

export interface BasicCallState {
  type: CallFlow;
  teamId: string;
  billingGroupId: string;
  callRecordId: string;
  customerId: string;
  customerNumber: string;
}

interface BasicInboundCall extends BasicCallState {
  type: CallFlow.CUSTOMER_CALLING_SUPPORT_AGENT;
}

export interface SupportAgentResponseCall extends BasicInboundCall {
  customerCallId: string;
  supportAgentUserId: string;
}

export interface SupportAgentCallingCustomerState extends BasicCallState {
  type: CallFlow.SUPPORT_AGENT_CALLING_CUSTOMER;
  isCustomerLeg: boolean;
  supportAgentUserId: string;
  conferenceName?: string;
}

export const supportAgentResponseCallFormat = base64StringJsonFormat(
  objectJsonFormat<SupportAgentResponseCall>(
    {
      type: typedStringJsonFormat(CallFlow.CUSTOMER_CALLING_SUPPORT_AGENT),
      customerCallId: stringJsonFormat,
      supportAgentUserId: stringJsonFormat,
      teamId: stringJsonFormat,
      billingGroupId: stringJsonFormat,
      callRecordId: stringJsonFormat,
      customerId: stringJsonFormat,
      customerNumber: stringJsonFormat,
    },
    {},
  ),
);

export const supportAgentCallingCustomerFormat = base64StringJsonFormat(
  objectJsonFormat<SupportAgentCallingCustomerState>(
    {
      type: typedStringJsonFormat(CallFlow.SUPPORT_AGENT_CALLING_CUSTOMER),
      teamId: stringJsonFormat,
      billingGroupId: stringJsonFormat,
      isCustomerLeg: booleanJsonFormat,
      supportAgentUserId: stringJsonFormat,
      callRecordId: stringJsonFormat,
      customerId: stringJsonFormat,
      customerNumber: stringJsonFormat,
    },
    { conferenceName: stringJsonFormat },
  ),
);
